var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7415ad4441c72337746262bd2865a47bfda1bf2f"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import { SENTRY_DSN, BUILD_VERSION } from "./domain/env";

Sentry.init({
  dsn: SENTRY_DSN,
  release: "visualization-tool@" + BUILD_VERSION,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,

  ignoreErrors: [
    // The ResizeObserver error is actually not problematic
    // @see https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
    "ResizeObserver loop",
  ],
});
